import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logoutUser } from "./usersSlice";

/* ================= INITIAL STATE ================= */
const initialState = {
  allProducts: [],
  productsAdmin: [],
  productAdminGet: null,
  loading: false,
  error: null,
};

/* ================= THUNKS ================= */

// CLIENTS: todos los productos
export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}products`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: todos los productos
export const fetchProductsAdmin = createAsyncThunk(
  "products/fetchAdmin",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}products/admin`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: un producto
export const fetchProductAdmin = createAsyncThunk(
  "products/fetchOneAdmin",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}products/admin/${id}`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: cambiar stock
export const toggleProductStock = createAsyncThunk(
  "products/toggleStock",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}products/stock/`,
        { id }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: agregar
export const addProduct = createAsyncThunk(
  "products/add",
  async (product, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}products/add`,
        product
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: modificar
export const updateProduct = createAsyncThunk(
  "products/update",
  async (product, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_API}products/update`,
        product
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// ADMIN: eliminar
export const deleteProduct = createAsyncThunk(
  "products/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API}products/${id}`
      );
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

/* ================= SLICE ================= */



const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    clearProductAdminGet(state) {
      state.productAdminGet = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.allProducts = action.payload;
      })

      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchProductsAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductsAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.productsAdmin = action.payload;
      })

      
      .addCase(fetchProductAdmin.pending, (state, action) => {
        state.loading = true;
      })

      .addCase(fetchProductAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.productAdminGet = action.payload;
      })

      .addCase(fetchProductAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(toggleProductStock.pending, (state) => {
        state.loading = true;
      })

      .addCase(toggleProductStock.fulfilled, (state, action) => {
        state.loading = false;
        state.productsAdmin = state.productsAdmin.map((p) =>
          p.id === action.payload.product.id ? action.payload.product : p
        );
      })

      .addCase(toggleProductStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      })

      .addCase(addProduct.pending, (state) => {
        state.loading = true;
      })

      .addCase(addProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload
      })

      .addCase(addProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      })

      .addCase(updateProduct.fulfilled, (state, action) => {
        state.productsAdmin = state.productsAdmin.map((p) =>
          p.id === action.payload.id ? action.payload : p
        );
      })

      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.productsAdmin = state.productsAdmin.filter(
          (p) => p.id !== action.payload
        );
      })

      .addCase(fetchProductsAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(logoutUser, () => initialState);
  },
});

export const { clearProductAdminGet } = productsSlice.actions;
export default productsSlice.reducer;
